import {Component, Vue} from 'vue-property-decorator';
import * as Swal from 'sweetalert2'

@Component
export default class alertMixin extends Vue {

    $_alertMixin_saveSuccess ( title ) {
        if (!title) title = "Saved";
        (Swal as any).fire({
            position: 'top-end',
            type: 'success',
            toast:true,
            customClass:'swal-success',
            title: title,
            showConfirmButton: false,
            timer: 2000
        })
    }
    $_alertMixin_deleteSuccess ( title ) {
        if (!title) title = "Deleted";
        (Swal as any).fire({
            position: 'top-end',
            type: 'error',
            toast:true,
            customClass:'swal-success',
            title: title,
            showConfirmButton: false,
            timer: 2000
        })
    }
    $_alertMixin_swalConfirm (heading, message, type){
        return (Swal as any).fire({
            title: heading,
            text: message,
            type: type,
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes'
        }).then((result) => {
            //resolve(result.value)
            return result.value
        });
    }

    $_alertMixin_swalClose (heading, message, type){
        return (Swal as any).fire({
            title: heading,
            input:'checkbox',
            inputPlaceholder:
                'Check box to close ticket',
            text: message,
            type: type,
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes',
            inputValidator: (result) => {
                return !result && 'Please check box if you wish to close the ticket'
            }
        }).then((result) => {
            //resolve(result.value)
            return result.value
        });
    }
}